// IMPORT REACT
import React from "react";
import Axios from "axios";
import { withRouter } from 'react-router-dom';

// IMPORT CONTAINERS
import Layout from '../../Layout';

// IMPORT COMPONENTS
import YAContainer from '../../../components/Grid/Container';
import YASection from '../../../components/Grid/Section';
import YARow from '../../../components/Grid/Row';
import YAColumn from '../../../components/Grid/Column';
import YAText from '../../../components/Text';
import YAInput from '../../../components/Form/Input';
import YAButton from '../../../components/Form/Button';
import YAFormLink from '../../../components/Form/Link';
import YAAlert from '../../../components/Alert';

// IMPORT STYLES
// import {} from '../../styles';

class Login extends React.Component {

  render() {
    const lang = this.props.lang;
    const page = this.props.page;
    const bloginfo = this.props.bloginfo;
    return (
      <Layout lang={lang} page={page} bloginfo={bloginfo}
        header={
          <Header page={page} bloginfo={bloginfo} />
        }
        body={
          <div>
            <SectionMiddle page={page} history={this.props.history} />
          </div>
        }
      />
    );
  }
}

const Header = ({ page, bloginfo }) => (
  <div>
    <YARow center>
      <YAColumn size="col-md-8 col-lg-6">
        <YAText tag="h1" bootstrap="display-4 mb-3">
          {page ? page.post_title : null}
        </YAText>
        <YAText tag="p" bootstrap="lead">
          {page ? page['meta']['page_section_0_text'] : null}
        </YAText>
      </YAColumn>
    </YARow>
  </div>
);

const SectionMiddle = ({ page, history }) => (
  <YASection padding={{ 'top': '2rem' }}>
    <YAContainer>
      <YARow center>
        <YAColumn size="col-md-10 col-lg-8">

          <LoginForm history={history} />

        </YAColumn>
      </YARow>
    </YAContainer>
  </YASection>
);

class LoginForm extends React.Component {

  state = {
    formSuccess: null,
    formError: null,
    branches: null,
    selectedProvince: null,
    selectedLocation: null,
    loginURL: null
  }

  componentDidMount() {
    this.getBranches().then((data) => {
      this.setState({ branches: data });
    });
  }

  getBranches() {
    return Axios({
      method: 'get',
      url: 'https://regions.weemarkable.ca/api/1.0/branch'
    }).then((response) => {
      if (response.data) {
        return response.data.data;
      } else {
        console.log(response, 'response error');
      }
    }).catch((error) => {
      console.log(error, 'error');
    });
  }

  groupBy(collection, property) {
    var i = 0, val, index,
      values = [], result = [];
    for (; i < collection.length; i++) {
      val = collection[i][property];
      index = values.indexOf(val);
      if (index > -1)
        result[index].push(collection[i]);
      else {
        values.push(val);
        result.push([collection[i]]);
      }
    }
    return result;
  }

  weemarkableAppLogin() {
    let url = this.state.loginURL;
    let emailAddress = document.getElementsByName("emailAddress")[0].value;
    let password = document.getElementsByName("password")[0].value;
    return Axios({
      method: 'POST',
      data: {
        emailAddress: emailAddress,
        password: password,
        url: url
      },
      url: '/wp-json/wp/v2/weemarkable/login/'
    }).then((response) => {
      if (response.data.error) {
        this.setState({
          formError: response.data.error,
          formSuccess: null
        });
      } else if (response.data.success) {
        this.setState({
          formError: null,
          formSuccess: response.data.success
        });
        if (response.data.redirect) {
          window.location.href = response.data.redirect;
          // this.props.history.push(response.data.redirect)
        }

      }
    }).catch((error) => {
      this.setState({
        formError: error.toString(),
        formSuccess: null
      });
    });
  }

  render() {
    let formError = this.state.formError;
    let formSuccess = this.state.formSuccess;
    let branches = this.state.branches;
    let branchesGrouped = branches ? this.groupBy(branches, 'province') : null;
    let selectedProvince = this.state.selectedProvince;
    let selectedLocation = this.state.selectedLocation;
    let url = this.state.loginURL;

    let provinceOptions = branchesGrouped ? branchesGrouped.map((branch) => {
      return ({
        value: branch[0].province,
        label: branch[0].province
      });
    }) : null;

    let branchOptions = branches ? branches.filter((branch) => {

      if (branch.province == selectedProvince) {
        return true;
      }

    }).map((branch) => {
      return ({
        value: branch.id,
        label: branch.name
      });
    }) : null;


    return (
      <form id="app-login">

        {formError ?
          <YAAlert color="danger">{formError}</YAAlert>
          : null}
        {formSuccess ?
          <YAAlert color="success">{formSuccess}</YAAlert>
          : null}

        <YAInput label="Province" name="province" type="select" options={provinceOptions} onChange={() => {
          this.setState({
            selectedProvince: document.getElementsByName("province")[0].value
          })
          this.setState({
            selectedLocation: null
          })
        }} />


        <YAInput label="Location" name="location" type="select" options={branchOptions} disabled={selectedProvince ? 0 : 1} onChange={() => {
          const locationID = document.getElementsByName("location")[0].value;
          let locationInfo = branches.filter(obj => {
            return obj.id == locationID
          })
          this.setState({
            selectedLocation: locationID,
            loginURL: locationInfo[0].url
          })
        }} />


        <YAInput label="Email" name="emailAddress" disabled={selectedLocation ? 0 : 1} />
        <YAInput label="Password" name="password" type="password" disabled={selectedLocation ? 0 : 1} />
        {selectedLocation ? <YAFormLink href={url + '/forgot'} color="link">Forgot Password?</YAFormLink> : <br />}
        <YAButton color="primary" block disabled={selectedLocation ? 0 : 1} onClick={(e) => {
          e.preventDefault();
          this.weemarkableAppLogin();
        }}>
          Submit
        </YAButton>
      </form >
    )
  }
}

export default withRouter(Login);